import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    stuff:'things',
    profileLoaded:false,
    loggedIn: false,
    isAdmin: false
  },
  mutations: {
    updateStuff (state, payload) {
      console.log('updateStuff: ', payload);
      let currentUser = firebase.auth().currentUser;
      state.loggedIn = (currentUser) ? true: false;
      if(payload.admin) {
        state.profileLoaded = true;
        state.isAdmin = true;
      }
      
    },
    logout(state) {
      state.loggedIn = false;
      state.isAdmin = false;
    }
  },
  getters: {
    isLoggedIn: (state) => {
      console.log(state.stuff);
      let currentUser = firebase.auth().currentUser;
      console.log('store isLoggedIn: currentUser: ', currentUser);
      return (currentUser) ? true: false;
    }
  },
  actions: {
    updateUser({commit}) {
      return new Promise((resolve) => {
        let currentUser = firebase.auth().currentUser;
        if(currentUser) {
          firebase.firestore().collection('users').doc(currentUser.uid).get().then((doc) => {
            let user = doc.data();
            console.log('User:', user);
            let payload = {admin:false}
            if(user && user.admin) {
              payload.admin = true;
            }
            commit('updateStuff', payload);
            resolve(user);
          });
        }
        else {
          commit('updateStuff', {});
          resolve({});
        }
      });
    }
  }
})
